export default __webpack_public_path__ + "static/media/le_lion6.ea4a5bbe.jpg";